import { render, staticRenderFns } from "./order-filter.vue?vue&type=template&id=2c87f222&scoped=true&"
import script from "./order-filter.component.ts?vue&type=script&lang=ts&"
export * from "./order-filter.component.ts?vue&type=script&lang=ts&"
import style0 from "./order-filter.scss?vue&type=style&index=0&id=2c87f222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87f222",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c87f222')) {
      api.createRecord('2c87f222', component.options)
    } else {
      api.reload('2c87f222', component.options)
    }
    module.hot.accept("./order-filter.vue?vue&type=template&id=2c87f222&scoped=true&", function () {
      api.rerender('2c87f222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/milk-run/components/order-filter/order-filter.vue"
export default component.exports